/**
 * @todo тогда может заменить на `gap`, как в `ButtonGroup`?
 */
export const Size = {
  SMALL: 's',
  LARGE: 'l',
  NONE: 'none',
} as const;

export type Size = Union<typeof Size>;
